import { Address } from '@app/models/address';
import { gql } from 'apollo-angular';

export interface AgencyDisplaySettings {
  hiddenTrainCompositionColumns: string[];
}

export enum AgencySybTypeId {
  Cargo = 'C',
  Passenger = 'P',
  Infra = 'I',
  Oss = 'O'
}

export interface AgencySubtypeId {
  id: string;
  description: string;
}

export interface Agency {
  id?: number;
  name?: string;
  defaultAgencySubTypeId?: AgencySubtypeId;
  agencySubTypes?: AgencySubtypeId[];
  uicId?: string;
  applicant?: boolean;
  ru?: boolean;
  im?: boolean;
  coss?: boolean;
  production?: boolean;
  service?: boolean;
  admin?: boolean;
  pathfinderMember?: boolean;
  unknownAgency?: boolean;
  agencyDisplaySettings?: AgencyDisplaySettings;
  shortName?: string;
  preferredAgency?: Agency;
  active?: boolean;
  address?: Address;
  country?: Country;
}

export interface Country {
  id?: string;
  description?: string;
  uicNetCode?: string;
  responsibleImAgency?: Agency;
}

export interface AgencyType {
  id: string;
}
export const agencySubTypeId = gql`
  fragment agencySubTypeId on AgencySubTypeId {
    id
    description
  }
`;
export const agencyBasic = gql`
  fragment agencyBasic on Agency {
    id
    name
    shortName
  }
`;

export const country = gql`
  fragment country on Country {
    id
    description
    uicNetCode
    responsibleImAgency {
      ...agencyBasic
    }
  }
  ${agencyBasic}
`;

export const agencyDetailed = gql`
  fragment agencyDetailed on Agency {
    id
    name
    shortName
    defaultAgencySubTypeId {
      ...agencySubTypeId
    }
    agencySubTypes {
      ...agencySubTypeId
    }
    uicId
    applicant
    ru
    im
    coss
    production
    service
    admin
    pathfinderMember
    unknownAgency
    agencyDisplaySettings {
      hiddenTrainCompositionColumns
    }
    active
    preferredAgency {
      ...agencyBasic
    }
    country {
      ...country
    }
  }
  ${agencySubTypeId}
  ${agencyBasic}
  ${country}
`;
